import React, { useState, useEffect } from 'react'
import { EditorState, convertFromHTML, convertFromRaw, ContentState } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { get } from 'lodash'

function NewsletterEditor({ setHTML, newsletter, baseBody }) {
  //
  /*const contentState = get(newsletter, 'html')
    ? EditorState.createWithContent(
        ContentState.createFromBlockArray(convertFromHTML('<p>Loading ...</p>')),
      )
    : EditorState.createEmpty()*/

  const [editorState, setEditorState] = useState(EditorState.createEmpty())

  useEffect(() => {
    console.log('out')
    if (baseBody) {
      console.log('in')
      setEditorState(EditorState.createWithContent(convertFromRaw(baseBody.body || baseBody)))
    }
  }, [baseBody])

  useEffect(() => {
    if (get(newsletter, 'html.body')) {
      setEditorState(EditorState.createWithContent(convertFromRaw(get(newsletter, 'html.body'))))
    }
  }, [newsletter])

  useEffect(() => {
    setHTML(editorState)
  }, [editorState])

  return (
    <div>
      <Editor
        editorState={editorState}
        toolbarClassName="rdw-editor-toolbar"
        wrapperClassName="rdw-editor-toolbar"
        editorClassName="h-64"
        onEditorStateChange={setEditorState}
      />
    </div>
  )
}

export default NewsletterEditor
